import api from '../../../utils/api';
import { PROCESSOR_DIRECTORY_FIXTURES } from '../fixtures/processorDirectory';

/**
 * Merged search hits GET /processors/search/ (directory + Mapbox, token server-side).
 * Detail still uses GET /processors/:id/. Submit always posts.
 */
export const PROCESSOR_API_READY = true;

export function processorSearchParams({
  latitude,
  longitude,
  radiusMiles,
  source,
  confirmedThisSeason,
} = {}) {
  const params = {
    lat: latitude,
    lng: longitude,
    radius_miles: radiusMiles,
  };
  if (source) params.source = source;
  if (confirmedThisSeason) params.confirmed_this_season = true;
  return params;
}

export function unwrapProcessorList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  return [];
}

export function normalizeProcessorRow(row) {
  if (!row || typeof row !== 'object') return null;
  const latitude = Number(row.latitude);
  const longitude = Number(row.longitude);
  return {
    ...row,
    id: row.id == null ? row.id : String(row.id),
    latitude: Number.isFinite(latitude) ? latitude : null,
    longitude: Number.isFinite(longitude) ? longitude : null,
    source: row.source || 'yona',
  };
}

function fixtureById(id) {
  return PROCESSOR_DIRECTORY_FIXTURES.find((row) => String(row.id) === String(id)) || null;
}

function isNotFound(error) {
  return error?.response?.status === 404;
}

export async function searchProcessors(
  args,
  { apiReady = PROCESSOR_API_READY } = {}
) {
  if (!apiReady) {
    return {
      rows: PROCESSOR_DIRECTORY_FIXTURES.map((row) => normalizeProcessorRow(row)),
      trace: null,
    };
  }
  const res = await api.get('/processors/search/', { params: processorSearchParams(args) });
  return {
    rows: unwrapProcessorList(res.data).map(normalizeProcessorRow).filter(Boolean),
    trace: res.data?.trace || null,
  };
}

export async function fetchProcessor(id, { apiReady = PROCESSOR_API_READY } = {}) {
  if (!apiReady) {
    const row = fixtureById(id);
    return row ? normalizeProcessorRow(row) : null;
  }
  try {
    const res = await api.get(`/processors/${id}/`);
    return normalizeProcessorRow(res.data);
  } catch (error) {
    if (isNotFound(error)) return null;
    throw error;
  }
}

export async function submitProcessor(payload) {
  const res = await api.post('/processors/', payload);
  return res.data;
}

export async function confirmProcessor(id, state) {
  const res = await api.post(`/processors/${id}/confirmations/`, { state });
  return res.data;
}

export async function checkInProcessor(id, { season } = {}) {
  const res = await api.post(`/processors/${id}/check-ins/`, { season });
  return res.data;
}
